import HelperMixin from '../../../Shared/HelperMixin.vue';

export default {
    name: 'PaymentMethods',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        this.GetInfo();
    },

    data() {
        return {
            Search: '',
            ScreenTitle: 'طرق الدفع',
            Info: [],
            FilteredInfo: []
        };
    },

    methods: {
        GetInfo() {
            this.$blockUI.Start();
            this.$http.GetAllPaymentMethods()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.FilteredInfo = this.Info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.FilteredInfo = [];
                });
        },

        filterData() {
            if (!this.Search) {
                this.FilteredInfo = this.Info;
            } else {
                const searchLower = this.Search.toLowerCase();
                this.FilteredInfo = this.Info.filter(item =>
                    item.name.toLowerCase().includes(searchLower)
                );
            }
        }
    }
};
